<div class="modal-container backorder-cart-modal-container modal-lg">
  <div class="modal-content">
    <div class="modal-header d-flex align-items-center">
      <h4 class="modal-title">{{ 'cart.backOrderCartModal.title' | cxTranslate }}</h4>
      <button
        class="close"
        aria-label="Close"
        (click)="closeModal('Cross click')"
        [disabled]="addToCartInprogressModal"
      >
        <mat-icon svgIcon="modal-x-icon"></mat-icon>
      </button>
    </div>
    <div class="modal-body">
      <p [innerHTML]="'cart.backOrderCartModal.description' | cxTranslate"></p>

      <div class="backorder-table">
        <table class="backorder-product-table">
          <tr class="header">
            <th>{{ 'cart.backOrderCartModal.skuLabel' | cxTranslate }}</th>
            <th>{{ 'cart.backOrderCartModal.totalQtyLabel' | cxTranslate }}</th>
            <th>{{ 'cart.backOrderCartModal.shipmentDateLabel' | cxTranslate }}</th>
            <th>{{ 'cart.backOrderCartModal.addToCartLabel' | cxTranslate }}</th>
          </tr>

          <tr *ngFor="let backorder of backorderEntries['inventoryBackorderList']; let index = index">
            <td>
              <a href="/orders?item={{ backorder.productId }}&view=backorder" target="_blank">{{
                backorder.productId
              }}</a>
            </td>
            <td>{{ backorder.quantity }}</td>
            <td>
              {{ backorder.availDate | date : dateFormatted }}
            </td>
            <td>
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  [(ngModel)]="backorder.checkBox"
                  [checked]="backorder.checkBox"
                  [value]="backorder.checkBox"
                  (change)="checkboxUpdate()"
                />
              </div>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <div class="modal-footer justify-content-sm-between justify-content-md-end">
      <button
        type="button"
        class="btn secondary-btn"
        [ngClass]="activeLanguage$ | async"
        [class.disabled]="addToCartInprogressModal"
        (click)="closeModal('Cross click')"
        [disabled]="addToCartInprogressModal"
      >
        {{ 'cart.backOrderCartModal.cancelBtn' | cxTranslate }}
      </button>
      <button
        type="button"
        class="btn primary-btn"
        [ngClass]="activeLanguage$ | async"
        [class.rotating]="addToCartInprogressModal"
        (click)="saveBackorder()"
        [disabled]="filteredEntries.length < 1 && nonBackorder?.length < 1"
      >
        <ng-container *ngIf="!addToCartInprogressModal; else showSpinner">
          {{ 'cart.backOrderCartModal.addToCartBtn' | cxTranslate }}
        </ng-container>
        <ng-template #showSpinner></ng-template>
      </button>
    </div>
  </div>
</div>
